/* eslint-disable @typescript-eslint/no-explicit-any */

export type TOptionTypeUi = {
  id?: string;
  __isNew__?: boolean;
  value: string | any;
  label: string;
};

export type TYesNoOptionType = 'Yes' | 'No' | null;

export type TEditingYesNoFieldUI = {
  value: TYesNoOptionType;
  canEdit: boolean;
};

export type TEditingYesNoFieldDB = TEditingBooleanField;

export type TSelectValueUI = TOptionTypeUi | undefined;
export type TSelectValueDB = {
  predefinedId: string | null;
  value: string | null;
};

export type TOptionType = {
  id?: string;
  value?: string;
};

export type TVetRecordTypeUI = {
  predefined?: string;
  custom?: string;
};

export type TVetRecordType = {
  predefined: string;
  value: string;
};

export type TExpirationDateType = {
  expired?: boolean;
  expirable: boolean;
  date: string;
};

export enum EFileTypeUI {
  VIDEO = 'video',
  PHOTO = 'image',
  OTHER = 'other',
}

export type TFileUI = {
  url: string;
  name: string;
  type: EFileTypeUI;
};

export type TFraudEvaluationStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED'
  | 'UNSUPPORTED';

export type TFraudEvaluationDb = {
  status: TFraudEvaluationStatus;
  overallResult?: string | null;
  decision?: string | null;
  confidence?: number | null;
  shortReason?: string | null;
  fraudSignals?: string | null;
  caseId?: string | null;
  partialResult?: boolean | null;
  aiRecommendation?: string | null;
  evaluatedAt?: string | null;
};

export type TFraudEvaluationUI = {
  status: TFraudEvaluationStatus;
  overallResult: string | null;
  confidence: number | null;
  shortReason: string | null;
  fraudSignals: string[];
  caseId: string | null;
  caseUrl: string | null;
  partialResult: boolean;
};

export type TFileDataType = {
  createdBy: string;
  createdDate: string;
  documentFileId: string;
  name: string;
  url: string;
  esaFraudCheck?: string | null;
  fraudEvaluation?: TFraudEvaluationDb | null;
  caseUrl?: string | null;
};

export type TFileDataTypeUI = {
  createdBy: string;
  createdDate: string;
  documentFileId: string;
  name: string;
  url: string;
  esaFraudCheck?: string | null;
  fraudEvaluation?: TFraudEvaluationUI | null;
};

export type TErrorField = {
  name: string[];
  errors: string[];
  warnings: string[];
};

export type TValidateFieldsError = {
  errorFields: TErrorField[];
  outOfDate: boolean;
};

export enum EValueEditingStates {
  UPDATE = 'UPDATE',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  SET = 'SET',
}

export enum EValueEditingStatesUi {
  UPDATE = 'UPDATE',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  SET = 'SET',
}

export enum EVetRecordTypeEnum {
  'RABIES' = 'Rabies',
}

export enum EVetRecordTypeEnumUi {
  'RABIES' = 'Rabies',
  'VACCINATION' = 'Vaccination',
}
export type TEditingField = {
  predefinedId: string | null;
  value: string | null;
  allowedOperations: EValueEditingStates[];
};

export type TEditingFieldUi = {
  id: string;
  value: string;
  canEdit: boolean;
  canRemove: boolean;
  canAdd: boolean;
};

export type TEditingBooleanField = {
  value: boolean;
  allowedOperations: EValueEditingStates[];
};

export type TEditingBooleanFieldUi = {
  value: boolean;
  canEdit: boolean;
};

export enum EGenderUi {
  FEMALE = 'Female',
  MALE = 'Male',
}

export enum EGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

export enum EReproductive {
  SPAYED = 'Spayed',
  NEUTERED = 'Neutered',
}

export enum EFailTypeUI {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
export enum EFailType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
export enum EVerificationStatus {
  NONE = 'NONE',
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
}
export enum EVerificationStatusUi {
  NOT_VERIFIED = 'Not verified',
  VERIFIED = 'Verified',
  PENDING = 'Pending',
}

export enum EApplicationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
  RETRACTED = 'RETRACTED',
  ABANDONED = 'ABANDONED',
}

export enum EApplicationStatusUi {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  ARCHIVED = 'Archived',
  RETRACTED = 'Retracted',
  ABANDONED = 'Abandoned',
}

export type TFailUI = { field: string; reason: string };
export type TFail = { [key: string]: string };

export enum ETextMessage {
  DEFAULT_ERROR_MESSAGE = 'Something went wrong',
  DEFAULT_SUCCESS_MESSAGE = 'Successfully done',
  DEFAULT_WARNING_TITLE = 'Missing information',
  MISSING_DOCUMENTS = 'Missing documents',
  VACCINATION_NO_EXPIRE = 'Documentation is from a licensed veterinarian exempting my animal from a rabies vaccination due to the animals age/health condition.',
  VACCINATION_OTHER_NO_EXPIRE = 'Vaccination has no expiration.',
  HP_FORM_TEXT = 'To verify documentation, OurPetPolicy uses a simple form for health professionals to complete with only the minimum information required to confirm an individual’s need for an assistance animal. The health professional can answer the questions on the form, by email, or by phone directly with OurPetPolicy. We will never ask for details about a patient’s disability or diagnosis.',
  HP_FORM_CREATE_TEXT = "Housing providers have the right to make the truth and accuracy of assistance animal documentation to the same extent they verify other material information during the leasing process, such as income verification. To facilitate this process for ESA and service animal letters, OurPetPolicy utilizes a simple form for the health professional to complete, which only asks the minimum information that is required to confirm an individual's need for an assistance animal as a reasonable accommodation. Health professionals are welcome to answer the questions on the form in another manner if preferred, such as over the phone or via email directly with OurPetPolicy. OurPetPolicy will never ask any details about a patient's disability or specific diagnosis. If you have any questions or concerns about this process, please contact us at support@ourpetpolicy.com.",
}

export type TPropertyManagementInfoUI = {
  propertyManagementId: string | null;
  propertyManagementName: string | null;
  propertyManagementLogo: string | null;
  firstLetters: string;
};

export type TPropertyManagementInfoDB = {
  propertyManagementId: string | null;
  propertyManagementName: string | null;
  propertyManagementLogo: string | null;
};

export type TPropertyInfoDB = {
  propertyId: string | null;
  propertyName: string | null;
};
export type TPropertyInfoUI = {
  propertyId: string | null;
  propertyName: string | null;
};

export enum EAnimalPetChargeStatusUI {
  NOT_APPLICABLE = 'Not applicable',
  UNSPECIFIED = 'Unspecified',
  BEING_CHARGED = 'Being charged',
  NOT_BEING_CHARGED = 'Not being charged',
  GRACE_PERIOD = 'Grace period',
  SHOULD_NOT_BE_CHARGE = `Shouldn't be charged`,
  NO_PET_FEE = 'No pet fee',
  NO_PET_RENT = 'No pet rent',
}

export enum EAnimalPetChargeStatusDB {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNSPECIFIED = 'UNSPECIFIED',
  BEING_CHARGED = 'BEING_CHARGED',
  NOT_BEING_CHARGED = 'NOT_BEING_CHARGED',
  GRACE_PERIOD = 'GRACE_PERIOD',
  SHOULD_NOT_BE_CHARGE = `SHOULD_NOT`,
  NO_PET_FEE = 'NO_PET_FEE',
  NO_PET_RENT = 'NO_PET_RENT',
}

export type TStatusChangeInfoDB = {
  by?: string;
  date?: string;
  reason?: string;
  dueDate?: string;
  statusChangerOrgName?: string;
  statusChangerRole?: string;
  moveOutDate?: string;
};
export type TStatusChangeInfoUI = {
  by?: string;
  date?: string;
  reason?: string;
  dueDate?: string;
  statusChangerOrgName?: string;
  statusChangerRole?: string;
  moveOutDate?: string;
};
export type TStatusInfoWithSourceUI = TStatusChangeInfoUI & {
  exportDate?: string;
  name?: string;
  url?: string;
  moveOutDate?: string;
};
export type TStatusInfoWithSourceDB = TStatusChangeInfoDB & {
  exportDate?: string;
  name?: string;
  url?: string;
  moveOutDate?: string;
};
export type TSignatureType =
  | 'ESA_FORM'
  | 'SERVICE_FORM'
  | 'PET_FORM'
  | 'GENERAL_FORM';

export type TSignature = {
  name: string;
  date: string;
  docType?: TSignatureType | null;
};

export type TMultiOptionTypeMaterialUI = {
  value: string;
  label: string;
};
